module.exports = __webpack_public_path__ + "media/images/official/special_hopper_toyoda_01-32de74789439041a254cc22b5ca88c53.png";